export class UpdatePostPurchaseVal {
  name?: string;
  currentVal?: string;
  newVal?: string;
}
